import type { DatasetsMutatorProps } from "./datasets-mutator.type";

import DatasetsMutatorCreate from "./datasets-mutator-create";
import DatasetsMutatorDelete from "./datasets-mutator-delete";
import DatasetsMutatorUpdate from "./datasets-mutator-update";

const DatasetsMutator = ({
  interventionId,
  sectionLayoutIndex,
  sectionAssetId,
  sectionObservationId,
  onObservationCreate,
  onDatasetDelete,
  createInvalidateKeys,
  updateInvalidateKeys,
  deleteInvalidate,
}: DatasetsMutatorProps) => {
  return (
    <>
      <DatasetsMutatorCreate
        interventionId={interventionId}
        sectionLayoutIndex={sectionLayoutIndex}
        sectionAssetId={sectionAssetId}
        sectionObservationId={sectionObservationId}
        onObservationCreate={onObservationCreate}
        invalidateKeys={createInvalidateKeys}
      />
      <DatasetsMutatorUpdate invalidateKeys={updateInvalidateKeys} />
      <DatasetsMutatorDelete
        onDatasetDelete={onDatasetDelete}
        invalidate={deleteInvalidate}
      />
    </>
  );
};

export default DatasetsMutator;
